"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _headlight = _interopRequireDefault(require("./headlight.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(_ref) {
  var style = _ref.style,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _headlight["default"].headlightWrapper,
    style: style
  }, children);
};